import React from 'react';

import * as styles from './CarouselDots.styles';

export interface CarouselDotsProps {
  currentMedia: number;
  totalMedia: number;
}

export const CarouselDots = ({ currentMedia, totalMedia }: CarouselDotsProps) => {
  return (
    <div aria-hidden="true" css={styles.root} data-testid="carousel-dots">
      {Array.from({ length: totalMedia }, (_, i) => (
        <span css={styles.dot} data-active={i === currentMedia} key={i} />
      ))}
    </div>
  );
};
